import React from 'react';
import { withTranslation } from 'react-i18next';
import Colors from 'assets/colors';
// import EmptyState from 'components/EmptyState';
import GameIcon from 'assets/icons/gamegroup.svg'
import GameCard from './GamesCard';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import Spinner from 'components/Spinner';
import EmptyState from 'components/EmptyState';
// import images from 'assets/img'

export default withTranslation()(function Games({ t }) {
  // Example data for the GameCard
  const { data , isValidating } = useSWR('/promos/give-aways?status=ongoing')

  const gameCardData = data?.data
    ? data.data.map((game, idx) => ({
      id: game.id,
      title: game.name,
      description: game.description,
      date: game.created_at?.split(' ')[0],
      start: game.start_date,
      end: game.end_date,
      total_sales: `₦${game.total_sales?.toLocaleString?.() || game.total_sales}`,
      total_points: game.total_points,
      total_players: game.total_players,
      status: game.status,
      avatar: game.avatar,
      onViewMore: () => {
        // Handle view more action
      }
    }))
    : [];


  const navigate = useNavigate()

  const onMenuItemClick = (gameId, item) => {
    console.log(gameId, item)
    navigate(`/promo/games?screen=${item?.toLowerCase()}&game=${gameId}`)

  }

  return (
    <div className=" w-full">

      <div className="flex w-full h-full">
        {/* <CampaignTable hideHeader={true} /> */}
        <div className='w-full'>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 w-full">
            {[
              { title: 'Total sales', amount: '₦5,000' },
              { title: 'Total Participation', amount: '₦10,000' },
              { title: 'Total Unique Participation', amount: '₦7,500' },
              { title: 'Leaderboard', amount: '₦12,000' },
              { title: 'Top branches', amount: '₦3,000' },
            ].map((game, idx) => (
              <div
                key={idx}
                className="flex flex-col justify-between rounded-lg p-5 h-32 border w-full"
              >
                <span className="text-md font-semibold text-gray-800">{game.title}</span>
                <span className="text-2xl font-bold text-gray-800">{game.amount}</span>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <div className="flex border-b mb-4">
              <button
                type="button"
                style={{ borderBottomColor: Colors.primary }}
                className="px-4 py-2 text-sm font-medium text-gray-700 border-b-2  focus:outline-none"
              >
                {t('promo.ongoing') || 'Ongoing'}
              </button>
              <button
                type="button"
                className="px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                {t('promo.past') || 'Past'}
              </button>
            </div>
            {/* Tab content goes here */}
            {/* */}

            <div className='flex flex-col gap-3 !w-[100%]'>
              {
                isValidating? <Spinner /> :
               data?.data?.length ? gameCardData.map((game, idx) => (
                <GameCard
                  key={game?.id}
                  title={game.title}
                  description={game.description}
                  date={game.date}
                  start={game.start}
                  end={game.end}
                  total_sales={game.total_sales}
                  total_points={game.total_points}
                  total_players={game.total_players}
                  status={game.status}
                  onViewMore={game.onViewMore}
                  avatar={game.avatar}
                  onMenuItemClick={(item) => onMenuItemClick(game?.id, item)}
                />
              )): <EmptyState icon={<img src={GameIcon} alt="Game icon" />} title={'No ongoing games'} /> 
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
